export const PAGE_SIZE = 8;
export const REVIEW_ITEM_HEIGHT = 4.75; // rem
